var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 100,
    height: 99,
    transform: "translate(0.039 0.075)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CC_Icon_V3",
    "data-name": "CC Icon V3",
    transform: "translate(-0.039 -0.075)",
    opacity: 0.508,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ChronicCondition_Icon_3REV",
    transform: "translate(8.849 7.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13478",
    "data-name": "Path 13478",
    d: "M54.2,13.554A29.1,29.1,0,0,1,43.9,24.877V23.61c3.352,4.926,8.973,7.522,13.122,11.691A51.475,51.475,0,0,1,43.1,47.094l-.245-.245A48.4,48.4,0,0,1,53.22,34.2v2.534c-3.72-3.8-6.05-8.891-10.587-11.855l-.593-.409a29.981,29.981,0,0,1,11.916-11.16l.245.245h0Z",
    transform: "translate(-3.348 -13.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13479",
    "data-name": "Path 13479",
    d: "M28.4,18.629a29.024,29.024,0,0,1,.715,15.288l-.9-.9c5.314,1.124,10.547-.838,15.861-.9l1.7-.123.1,1.9a48.125,48.125,0,0,1-1.615,16.27H43.9A48.125,48.125,0,0,1,42.282,33.9l1.8,1.8c-5.314-.061-10.547-2-15.861-.9l-.695.123a29.915,29.915,0,0,1,.531-16.31h.368Z",
    transform: "translate(-10.274 -10.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13480",
    "data-name": "Path 13480",
    d: "M15.6,39.108a29.1,29.1,0,0,1,11.323,10.3H25.654c4.926-3.352,7.522-8.973,11.691-13.122A51.475,51.475,0,0,1,49.138,50.207l-.245.245A48.4,48.4,0,0,1,36.241,40.089h2.534c-3.8,3.72-8.891,6.05-11.855,10.587l-.409.593a29.981,29.981,0,0,1-11.16-11.916l.245-.245h0Z",
    transform: "translate(-15.352 -2.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13481",
    "data-name": "Path 13481",
    d: "M20.674,66.262a29.024,29.024,0,0,1,15.288-.715l-.9.9c1.124-5.314-.838-10.547-.9-15.861l-.123-1.7,1.9-.1A48.126,48.126,0,0,1,52.211,50.4v.368a48.125,48.125,0,0,1-16.27,1.615l1.8-1.8c-.061,5.314-2,10.547-.9,15.861l.123.695a29.915,29.915,0,0,1-16.31-.531v-.368h0Z",
    transform: "translate(-12.968 2.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13482",
    "data-name": "Path 13482",
    d: "M41.152,83.531a29.1,29.1,0,0,1,10.3-11.323v1.267c-3.352-4.926-8.973-7.522-13.122-11.691A51.475,51.475,0,0,1,52.251,49.991l.245.245A48.4,48.4,0,0,1,42.133,62.888V60.353c3.72,3.8,6.05,8.891,10.587,11.855l.593.409A29.981,29.981,0,0,1,41.4,83.776l-.245-.245h0Z",
    transform: "translate(-5.016 3.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13483",
    "data-name": "Path 13483",
    d: "M68.306,77.764a29.024,29.024,0,0,1-.715-15.288l.9.9c-5.314-1.124-10.547.838-15.861.9l-1.7.123-.1-1.9a48.125,48.125,0,0,1,1.615-16.27h.368A48.125,48.125,0,0,1,54.428,62.5l-1.8-1.8c5.314.061,10.547,2,15.861.9l.695-.123a29.915,29.915,0,0,1-.531,16.31h-.368Z",
    transform: "translate(0.553 1.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13484",
    "data-name": "Path 13484",
    d: "M85.589,52.157a29.1,29.1,0,0,1-11.323-10.3h1.267c-4.926,3.352-7.522,8.973-11.691,13.122A51.475,51.475,0,0,1,52.049,41.058l.245-.245A48.4,48.4,0,0,1,64.946,51.175H62.412c3.8-3.72,8.891-6.05,11.855-10.587L74.675,40a29.981,29.981,0,0,1,11.16,11.916l-.245.245h0Z",
    transform: "translate(1.154 -1.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13485",
    "data-name": "Path 13485",
    d: "M79.822,26.359a29.024,29.024,0,0,1-15.288.715l.9-.9c-1.124,5.314.838,10.547.9,15.861l.123,1.7-1.9.1a48.126,48.126,0,0,1-16.27-1.615v-.368a48.125,48.125,0,0,1,16.27-1.615l-1.8,1.8c.061-5.314,2-10.547.9-15.861l-.123-.695a29.915,29.915,0,0,1,16.31.531v.368h0Z",
    transform: "translate(-0.539 -8.23)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcIcon);
export default __webpack_public_path__ + "static/media/CC_Icon.4d44497a0f1c21cd02c3720b6d146288.svg";
export { ForwardRef as ReactComponent };